import type { RootState } from "infrastructure/store/types";

import generalReducer, { name as general } from "features/general/slice";
import authReducer, { name as auth } from "features/auth/slice";
import transactionsReducer, { name as transactions } from "features/transactions/slice";
import consumersReducer, { name as consumers } from "features/consumers/slice";
import merchantsReducer, { name as merchants } from "features/merchants/slice";
import paymentMethodsReducer, { name as paymentMethods } from "features/paymentMethods/slice";
import usersReducer, { name as users } from "features/users/slice";
import merchantPayoutsReducer, { name as merchantPayouts } from "features/merchantPayouts/slice";
import pivotsReducer, { name as pivots } from "features/pivots/slice";
import kycReducer, { name as kyc } from "features/kyc/slice";
import openBankingReducer, { name as openBanking } from "features/openBanking/slice";
import setupsReducer, { name as setups } from "features/setups/slice";
import onboardingReducer, { name as onboarding } from "features/onboarding/slice";
import pspKycSettingsReducer, { name as pspKycSettings } from "features/pspKycSettings/slice";

import {
    combineReducers,
    compose,
    type AnyAction,
    type Reducer
} from "../lib";

const rootReducer: (...func: Array<(func: [unknown, AnyAction]) => [unknown, AnyAction]>) => Reducer = (...func) =>
    (...args: [unknown, AnyAction]) => {
        const [state, action] = compose<[RootState, AnyAction]>(...func)(args);

        return combineReducers({
            [general]: generalReducer,
            [auth]: authReducer,
            [transactions]: transactionsReducer,
            [consumers]: consumersReducer,
            [merchants]: merchantsReducer,
            [users]: usersReducer,
            [paymentMethods]: paymentMethodsReducer,
            [merchantPayouts]: merchantPayoutsReducer,
            [pivots]: pivotsReducer,
            [kyc]: kycReducer,
            [openBanking]: openBankingReducer,
            [setups]: setupsReducer,
            [onboarding]: onboardingReducer,
            [pspKycSettings]: pspKycSettingsReducer,
            /**reducers go here */
        })(state, action);
    };

export default rootReducer;
